export interface IAntibodyScreeningResult {
    id: number; 
    screeningId: number;
    recipientId: number;
    serological: string;
    allele: string;
    normalMfi: number;
    countMfi: number;
    rawMfi: number;
    rxnMfi: number;
    bead: number;
    isDonorAllele: number;
    isDsa: boolean;
    isDeNovoDsa: boolean;
    dateDsaDetected: string;
    override: boolean;
    overrideWho: number;
}